/**
 * Toolbar formatting actions reported by `ArtifactEditorFormattingUsed`.
 *
 * The values are the wire contract for the existing Amplitude event and must not change.
 */
export enum ArtifactEditorFormatType {
  bold = 'bold',
  italic = 'italic',
  bulletList = 'bulletList',
  orderedList = 'orderedList',
}

/**
 * Where an artifact editor session was opened from. Reported only on ArtifactEditorOpened.
 * direct is the fallback when location.state has no known value (pasted URL, new tab, shared
 * link, or the Outlook handoff).
 */
export enum ArtifactEditorEntryPoint {
  Chat = 'chat',
  DraftPage = 'draft_page',
  MatterActivity = 'matter_activity',
  Direct = 'direct',
}
